import React, { useRef } from "react";
import { Modal, Box, IconButton, Button, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import domtoimage from "dom-to-image";
import { MemoryThankYouCard } from "./MemoryThankYouCard";

interface DownloadGraphicModalProps {
  open: boolean;
  onClose: () => void;
  deceasedName: string;
  backgroundImage: string;
  logoImage: string;
}

export const DownloadGraphicModal: React.FC<DownloadGraphicModalProps> = ({
  open,
  onClose,
  deceasedName,
  backgroundImage,
  logoImage,
}) => {
  const cardRef = useRef<HTMLDivElement | null>(null);

  const handleDownload = async () => {
    if (!cardRef.current) return;

    try {
      const node = cardRef.current;

      const dataUrl = await domtoimage.toPng(node, {
        width: 1080,
        height: 1080,
        bgcolor: "#ffffff",
        quality: 1,
        style: {
          transform: "scale(1)",
          transformOrigin: "top left",
          backgroundColor: "#ffffff",
        },
      });

      const link = document.createElement("a");
      link.download = `memory-${deceasedName.replace(/\s+/g, "_")}.png`;
      link.href = dataUrl;
      link.click();
    } catch (err) {
      console.error("❌ Error generating PNG:", err);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute" as const,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
          outline: "none",
          width: "auto",
          minWidth: 500,
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        {/* Graphic Preview */}
        <Box
          ref={cardRef}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            bgcolor: "#fff",
          }}
        >
          <MemoryThankYouCard
            deceasedName={deceasedName}
            backgroundImage={backgroundImage}
            logoImage={logoImage}
          />
        </Box>
        {/* Download Button */}
        <Stack direction="row" justifyContent="flex-end" mt={2}>
          <Button
            variant="contained"
            startIcon={<DownloadIcon />}
            onClick={handleDownload}
          >
            Download Graphic
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};
